module.exports = __webpack_public_path__ + "media/images/svg/jobs/cashier-21ff6b1748c0de3ac07091cd97252fe8.svg";